
export default class Search {
    public init(){
        const that = this;
        this.chooseCategory();

        $('.btn-search').on('click',function(){
            that.submit();
        })
    }

    public chooseCategory(){
        const $categoryItem = $('.js-category .item');
        const that = this;

        $categoryItem.on('click',function(e){
            const $this = $(this);
            const $classidInput = $('[name="classid"]');

            $classidInput.val($this.data('classid'));
            $this.addClass('cur').siblings('.item').removeClass('cur');
            that.submit();
        })
    }

    public submit(){
        const $keywordInput = $('.search-input');
        const keyword = String($keywordInput.val()) || '';

        if(keyword.length>0) {
            $('.js-auto-submit-search').submit();
        }
    }
}